module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAIAAAC2BqGFAAABH0lEQVR42uzdMQqCUBjAcU2Fp2ODByrqPkHniIjWoCFoqTN1gqCgQXCooc3VIl/8/uM3PPTH48PN/DKuE32/EQLQoAUaNGiBBi3QoEELNGiBBg1aoEELNGjQAg1aoEGDFmjQAg0atED/SfmgnqacTur9rjO8LpaP0xn0J0uzLK2q7rQorA6BBg1aoEELNGjQAg1aoEGDFmjQAg0atECDFmjQoAUatECDBi3QoAUaNGiBBi3QoEELNGiBBg1aoOMtHdT/DKv5rD4eOsNn0yRt2/Pk+2Z7W61/+Gp5BHchhCSEvoeUpdVhRws0aMXw1eFGCzRogQYNWqBBCzRo0AINWqBBgxZo0AINGrRAgxZo0KAFGrRAgwYt0KD17hUAAP//B3wVZu5QebIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/les-echos.png
// module id = eOFQ
// module chunks = 0